import { createTheme, alpha } from '@mui/material/styles';

/**
 * @param {import('./themePresets').ThemePreset} preset
 */
export const createAppTheme = (preset) =>
  createTheme({
    palette: {
      primary: {
        main: preset.primary,
        dark: preset.primaryDark,
        light: preset.primaryLight,
        contrastText: '#ffffff',
      },
      secondary: {
        main: preset.secondary,
        contrastText: '#ffffff',
      },
      /** Matches existing sx usage: bgcolor: 'blue.600' */
      blue: {
        600: preset.primary,
        700: preset.primaryDark,
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            '&:hover': {
              backgroundColor: preset.primaryDark,
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: { borderRadius: 8 },
        },
      },
      MuiChip: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: alpha(preset.primary, 0.12),
            color: preset.primaryDark,
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#f5f7fa',
          },
          '::selection': {
            backgroundColor: alpha(preset.primary, 0.25),
          },
        },
      },
    },
  });
